/*
 * @Author: CYX
 * @Date: 2020-07-09 18:38:43
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 09:19:58
 */ 
export const InquirySheetDetailsCn = {
    xunjiadanList: "询价单列表",
    xunjiadandetail: "询价单详情",
    baojiadan: "报价单",
    xunjiadan: "询价单",
    ceshixinxi: "测试信息",
    wenjiansc:'文件上传:',
    baojiazhong: "报价中",
    baojiaxinxi: "报价信息",
    feiyongheji: "费用合计：",
    chongxinbaojia: "重新报价",
    querenxiandan: "确认下单",
    baopjiayouxiaoqi: "报价有效期至",
    zaiyouxiaoqqxd: "请在有效时间前确认下单",
    ptbzxx: "平台备注信息",
    sfcxbj: "是否重新报价",
    zhankai: "展开",
    shouqi: "收起",
}


// WEBPACK FOOTER //
// ./src/lang/home/InquirySheetDetails/indexCn.js